function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#4B9B1E",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15.2 4C17.85 4 20 6.15 20 8.8v6.4c0 2.65-2.15 4.8-4.8 4.8H8.8C6.15 20 4 17.85 4 15.2V8.8C4 6.15 6.15 4 8.8 4zm3.05 11.725h-3.825c-.625 0-.55.263-.55.75v2.4h.625v-1.207c-.008-.069-.044-.58.563-.58h3.187v-.563h-3.625c-.162 0-.162-.237 0-.237h3.625v-.563zm0-1.588h-4.7c-.625 0-.55.263-.55.75v3.988h.625V16.08c-.008-.068-.044-.58.563-.58h4.062v-.563h-4.5c-.15 0-.15-.237 0-.237h4.5v-.563zm-8.688 1.588H5.739v.55H9.35c.162 0 .162.238 0 .238H5.738v.562h3.187c.637 0 .563.588.563.588v1.2h.625v-2.388c0-.475.075-.75-.55-.75zm.876-1.6h-4.7v.563h4.5c.15 0 .15.237 0 .237h-4.5v.563H9.8c.637 0 .563.587.563.587v2.788h.625v-3.976c0-.487.075-.75-.55-.762zm.8-1.575h-5.5v.55h5.387c.15 0 .15.238 0 .238H5.737v.55h4.95c.638 0 .563.587.563.587v4.388h.613v-5.45c0-.4-.238-.788-.625-.863zm7.012 0h-5.5c-.387.075-.625.45-.625.862v5.45h.625v-4.387s-.075-.588.563-.588h4.937v-.55h-5.387c-.15 0-.15-.237 0-.237h5.387v-.55zm-6.328-.472C11.377 10.472 9.952 8.871 8 8.213h1.137v-1.4h-3.4v2.45c1.4-.05 3.075.737 3.863 1.65H7.138v-1.35h-1.4v2.75h10.724v-1.4h-2.087c.625-.75 1.837-1.4 2.45-1.476V12.3h1.425V6.412h-1.425v.4h-1.987v1.4h1.15a6.394 6.394 0 0 0-4 4.075c.012 0 .012.002.012.013h-.025c.013 0 .013-.013.013-.025zm2.74-6.978H9.325v3.513c.5.312.975.675 1.375 1.112V6.45h2.588v3.275c.45-.487.925-.838 1.374-1.112V5.1z"
}));

var SvgIcBaac = function SvgIcBaac(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBaac, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_baac.11ed0c05.svg";
export { ForwardRef as ReactComponent };